import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import { API_GET_EMPLOYER_BY_ID, KEY_GET_EMPLOYER_BY_ID } from '../constants';
import { MOCK_RESPONSE_GET_EMPLOYER_BY_ID } from '../mocks';
import { Employer } from '../types';

type RequestEmployerById = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_PATH_KEY
>['request']['path'];

type ResponseEmployerById = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_PATH_KEY
>['response']['body'];

export type CallParamsGetEmployerById = Omit<RequestEmployerById, 'organizationId'> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponseGetEmployerById = ResponseEmployerById;

type CallErrorGetEmployerById = GenericApiError;

type CallSelectorsGetEmployerById = {
  employer: Employer | null;
};

export const getEmployerByIdCall = createGeneralCall<
  CallParamsGetEmployerById,
  CallResponseGetEmployerById,
  CallErrorGetEmployerById,
  CallSelectorsGetEmployerById
>({
  id: KEY_GET_EMPLOYER_BY_ID,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_GET_EMPLOYER_BY_ID(org, payload.employeeId);
    },
  method: 'get',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_EMPLOYER_BY_ID : undefined,
  selectors: {
    employer: ({ selectors }) =>
      createSelector(selectors.response, res => (res as Employer) || null),
  },
});
